define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FWpAssetChangeTypeDomain = void 0;
    class FWpAssetChangeTypeDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FWpAssetChangeTypeDomain.NewAsset, value: "New Asset" },
                    { key: FWpAssetChangeTypeDomain.EnhanceAsset, value: "Enhance Asset" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FWpAssetChangeTypeDomain.NewAsset] = 0;
                this.KeyIndex[FWpAssetChangeTypeDomain.EnhanceAsset] = 1;
                this.ValueIndex = {};
                this.ValueIndex["New Asset"] = 0;
                this.ValueIndex["Enhance Asset"] = 1;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FWpAssetChangeTypeDomain = FWpAssetChangeTypeDomain;
    Object.defineProperty(FWpAssetChangeTypeDomain, "NewAsset", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(FWpAssetChangeTypeDomain, "EnhanceAsset", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(FWpAssetChangeTypeDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
